import { registerComponent } from '@gig/magic-common';
import NumberComponent from './number.vue.js';

var NumberField = registerComponent(NumberComponent);

export { NumberField };
